import _classCallCheck from "/home/rewyer/sites/rewyer-client-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/rewyer/sites/rewyer-client-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/home/rewyer/sites/rewyer-client-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/rewyer/sites/rewyer-client-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/rewyer/sites/rewyer-client-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/rewyer/sites/rewyer-client-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module font/documentcolorcollection
 */
import Collection from '@ckeditor/ckeditor5-utils/src/collection';
import ObservableMixin from '@ckeditor/ckeditor5-utils/src/observablemixin';
import mix from '@ckeditor/ckeditor5-utils/src/mix';
/**
 * A collection to store document colors. It enforces colors to be unique.
 *
 * @mixes module:utils/observablemixin~ObservableMixin
 * @extends module:utils/collection~Collection
 */

var DocumentColorCollection = /*#__PURE__*/function (_Collection) {
  _inherits(DocumentColorCollection, _Collection);

  var _super = _createSuper(DocumentColorCollection);

  function DocumentColorCollection(options) {
    var _this;

    _classCallCheck(this, DocumentColorCollection);

    _this = _super.call(this, options);
    /**
     * Indicates whether the document color collection is empty.
     *
     * @observable
     * @readonly
     * @member {Boolean} #isEmpty
     */

    _this.set('isEmpty', true);

    return _this;
  }
  /**
   * Adds a color to the document color collection.
   *
   * This method ensures that no color duplicates are inserted (compared using
   * the color value of the {@link module:ui/colorgrid/colorgrid~ColorDefinition}).
   *
   * If the item does not have an ID, it will be automatically generated and set on the item.
   *
   * @chainable
   * @param {module:ui/colorgrid/colorgrid~ColorDefinition} item
   * @param {Number} [index] The position of the item in the collection. The item
   * is pushed to the collection when `index` is not specified.
   * @fires add
   */


  _createClass(DocumentColorCollection, [{
    key: "add",
    value: function add(item, index) {
      if (this.find(function (element) {
        return element.color === item.color;
      })) {
        // No duplicates are allowed.
        return;
      }

      _get(_getPrototypeOf(DocumentColorCollection.prototype), "add", this).call(this, item, index);

      this.set('isEmpty', false);
    }
    /**
     * @inheritdoc
     */

  }, {
    key: "remove",
    value: function remove(subject) {
      var ret = _get(_getPrototypeOf(DocumentColorCollection.prototype), "remove", this).call(this, subject);

      if (this.length === 0) {
        this.set('isEmpty', true);
      }

      return ret;
    }
    /**
     * Checks if an object with given colors is present in the document color collection.
     *
     * @param {String} color
     * @returns {Boolean}
     */

  }, {
    key: "hasColor",
    value: function hasColor(color) {
      return !!this.find(function (item) {
        return item.color === color;
      });
    }
  }]);

  return DocumentColorCollection;
}(Collection);

export { DocumentColorCollection as default };
mix(DocumentColorCollection, ObservableMixin);